<div class="col-md-6 offset-md-3 mt-5">
<div class="navbar-header">
        <a class="" rel="home" href="#" title="">
            <img class="responsive" style="width:100%;height: auto;"
                 src="assets/images/header-1.png">
        </a>
    </div>

        <section id="header" class="rounded" style="margin-top:1%;background-color:white;text-align: center;text-emphasis-color: inherit"><strong>IPSR Solutions Limited</strong>
                <div class="container">
                    <div class="row" >
                        <div class="col-md-12 col-xs-12 col-centered" style="align-items: center;
                        text-decoration: underline;">
                        <strong> Online Fee payment</strong></div>
                    </div>
                </div>
            </section>


    <div class="card" style="margin-top: 1%">
    <h4 class="card-header">Student Details</h4>
    <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="form-group">
                <label for="registrationNo">Registration No</label>
                <input type="text" placeholder="Enter registration Number" formControlName="registrationNo" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.registrationNo.errors }" />
                <div *ngIf="submitted && f.registrationNo.errors" class="invalid-feedback">
                    <div *ngIf="f.registrationNo.errors.required">Registration number is required</div>
                    <div *ngIf="f.registrationNo.errors.minlength && (!f.registrationNo.errors.required)">registrationNo required of length {{f.registrationNo.errors.minlength.requiredLength}} and has length {{f.registrationNo.errors.minlength.actualLength}}  </div>
                    <div *ngIf="f.registrationNo.errors.pattern && (!f.registrationNo.errors.required)">Invalid registration No   </div>
                </div>
            </div>

           <!--  <div class="form-group">
                <label for="password">Password</label>
                <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                </div>
            </div> -->
            <div class="form-group">
              <label> Captcha</label>
              <input matInput  onpaste="return false;" onCopy="return false" onCut="return false" placeholder="Enter Captcha"
                 class="captchaFeild"  formControlName="captcha" autocomplete="off"
               required minlength="6" maxlength="6"  onkeyup="this.value = this.value.toUpperCase();"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.captcha.errors }"/>
                <div *ngIf="submitted && f.captcha.errors " class="invalid-feedback">
                  <div *ngIf="f.captcha.errors.required">Captcha is required</div>
                  <div *ngIf="f.captcha.errors.incorrectcaptcha && (!f.captcha.errors.required)">Captcha is invalid </div>
                  <div *ngIf="f.captcha.errors.minlength && (!f.captcha.errors.required)">Captcha required of length {{f.captcha.errors.minlength.requiredLength}} and has length {{f.captcha.errors.minlength.actualLength}}  </div>
                </div>
             </div>
             <div id="capt">
                 <span onselectstart="return false" onpaste="return false;" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false">{{initialCap}}</span>
                 <span style="float: right; cursor: pointer;">
                         <i class="material-icons" (click)="Cap()">refresh</i>
                 </span>
            </div>
            <div class="form-group">
                <button [disabled]="loading" class="btn btn-primary">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Submit
                </button>
            </div>
        </form>
    </div>
    </div>
</div>
